import { Badge } from "@chakra-ui/react";
import { useMemo } from "react";

type Props = {
  currentValue: number;
  compareValue: number;
  invert?: boolean;
};

export function DifferenceBadge({
  currentValue,
  compareValue,
  invert = false,
}: Props) {
  const value = useMemo(
    () => 100 * (compareValue / currentValue - 1),
    [currentValue, compareValue]
  );

  const displayedDifference = useMemo(
    () =>
      value.toLocaleString(document.documentElement.lang, {
        signDisplay: "exceptZero",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      }),
    [value]
  );

  const brandColorName = useMemo(() => {
    if (value === 0) return "brand.gray";
    if (invert) return value < 0 ? "brand.red" : "brand.skyblue";
    return value > 0 ? "brand.red" : "brand.skyblue";
  }, [value, invert]);

  return (
    <Badge bg={`${brandColorName}.10`} color={`${brandColorName}.100`}>
      {displayedDifference}%
    </Badge>
  );
}
